// src/components/nav-bar.js
import React from 'react';
import { useTranslation } from 'react-i18next';
import { HashLink } from 'react-router-hash-link';
import { Link } from 'react-router-dom';
import Logo from '../assets/logo.svg';
import './nav-bar.css'; // if you have a separate file

const Navbar = ({ showAbout = true }) => {
  const { t } = useTranslation();

  return (
    <header className="header">
      <div className="padding-left logo-container">
        {/* internal SPA navigation back to home */}
        <Link to="/" className="logo-link">
          <img
            src={Logo}
            alt="SafeU – Cybersecurity Software & Services"
            className="logo-image"
          />
        </Link>
      </div>

      <div className="padding-right d-flex">
        {showAbout && (
          <HashLink
            smooth
            to="/#about"
            className="nav-button pe-4 d-sm-inline-flex"
          >
            {t('about')}
          </HashLink>
        )}
        <HashLink
          smooth
          to="/#form"
          className="filled-button d-none d-sm-inline-flex"
        >
          {t('contactUs')}
        </HashLink>
      </div>
    </header>
  );
};

export default Navbar;
